<template>
  <div>
    <Edit :item="currentItem" :close="closeEdit" :onSubmit="onSubmit" />
    <div class="filters row" style="margin-top: 0">
      <div class="col-1-3">
        <!--<span class="filters__search">-->
        <!--<input type="text" name="" value="" placeholder="Filtrar por nome">-->
        <!--<fa-icon icon="search"/>-->
        <!--</span>-->
      </div>
      <div class="col-2-3">
        <div class="pull-right">
          <button v-on:click="openCreate" class="button button-success button-block">
            <fa-icon icon="plus" />
            Criar
          </button>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <datatable :columns="table.columns" :data="items" class="table table-hover">
        <template slot-scope="{ row }">
          <tr>
            <td>{{ row.id }}</td>
            <td>{{ row.chave }}</td>
            <td>{{ row.etapa_atual_chave }}</td>
            <td>{{ row.proxima_etapa_chave }}</td>
            <td class="actions">
              <button type="button" class="button button-primary" v-on:click="openEdit(row)">
                <fa-icon icon="pencil-alt" />
              </button>
              <button type="button" name="button" v-on:click="deleteConfirm(row.id)" class="button button-error">
                <fa-icon icon="trash-alt" />
              </button>
            </td>
          </tr>
        </template>
      </datatable>
    </div>
    <div style="justify-content: center; display: flex">
      <pagination :data="table.paginator" :limit="5" @pagination-change-page="getData"></pagination>
    </div>
  </div>
</template>

<script>
import clone from "just-clone";
import {
  schemaNumber,
  schemaTextField
} from "@/helpers/form";
import { get, post, put, del } from "@/helpers/apiRequest";
import Edit from "./Edit.vue";

const initialItem = {
  tipo_ticket_id: "",
  etapa_atual_chave: "",
  proxima_etapa_chave: "",
};

export default {
  name: "EtapaCondicional",
  components: {
    Edit
  },
  data() {
    return {
      currentItem: {},
      niveis: [],
      loading: false,
      items: [],
      table: {
        columns: [
          { label: "ID", field: "id", sortable: false },
          { label: "Tipo Ticket", field: "tipo_ticket_id", sortable: false },
          { label: "Chave Etapa Atual", field: "etapa_atual_chave", sortable: false },
          { label: "Chave Próxima Etapa", field: "proxima_etapa_chave", sortable: false },
          { label: "AÇÕES", field: "actions", sortable: false },
        ],
        paginator: {},
      },
      formInputs: {
        tipo_ticket_id: schemaNumber('Tipo Ticket', 1, 4, true),
        etapa_atual_chave: schemaTextField('Chave Etapa Atual', 1, 4, true),
        proxima_etapa_chave: schemaTextField('Chave Próxima Etapa', 1, 4, false),
      },
    };
  },
  methods: {
    getData(page) {
      get(`/admin/sac/ticket-etapa-condicional?page=${page}`)
        .then(json => {
          this.items = json.itens;
          this.table.paginator = json.paginator;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    openEdit(item) {
      this.currentItem = clone(item);
      this.$modal.show("ticketEtapaCondicionalEdit");
    },
    openCreate() {
      this.currentItem = clone(initialItem);
      this.$modal.show("ticketEtapaCondicionalEdit");
    },
    closeEdit() {
      this.$modal.hide("ticketEtapaCondicionalEdit");
    },
    deleteConfirm(id) {
      this.$swal({
        title: "Confirma Remover?",
        text: "Essa ação não poderá ser desfeita",
        showCancelButton: true,
        icon: "warning",
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
      })
        .then((res) => {
          if (res.value) {
            this.loading = true;
            del(`/admin/sac/ticket-etapa-condicional/${id}`)
              .then((json) => {
                this.loading = false;
                this.getData(this.table.paginator.current_page);
                this.$swal({
                  title: "Removido com sucesso",
                  text: json.message,
                  showCancelButton: false,
                  cancelButtonText: "Fechar",
                  showConfirmButton: true,
                  icon: "success",
                });
              })
              .catch((err) => {
                this.loading = false;
                this.$swal({
                  title: "Falha ao remover",
                  icon: "error",
                });
              });
          }
        })
        .catch(() => { });
    },
    onSubmit(item) {
      this.loading = true;
      const request = this.request(item);
      request
        .then((json) => {
          this.closeEdit();
          this.getData();
          this.$swal({
            title: "Salvo com sucesso",
            text: json.message,
            showCancelButton: false,
            cancelButtonText: "Fechar",
            showConfirmButton: true,
            icon: "success",
          });
        })
        .catch((error) => {
          this.$swal({
            title: "Falha ao Salvar",
            text: error.message,
            showCancelButton: true,
            cancelButtonText: "Fechar",
            showConfirmButton: false,
            icon: "error",
          });
        });
      return request;
    },
    request(item) {
      if (item.id) {
        return put(`/admin/sac/ticket-etapa-condicional/${item.id}`, item);
      }
      return post(`/admin/sac/ticket-etapa-condicional`, item);
    },
  },
  beforeMount() {
    this.getData(1);
  }
};
</script>
